import { useCallback, useMemo } from "react";

import { isApiError } from "../../api/common";
import {
    composeErrorHandlers,
    ErrorHandler,
    ErrorHandlerCreator,
} from "../../utils/errorHandling";
import { toastError } from "../components/core";

export const useGeneralErrorHandlerCreator = (): ErrorHandlerCreator => {
    return useCallback((next) => {
        return (error) => {
            if (isApiError(error)) {
                if (error.errors && error.errors.length) {
                    toastError(error.errors[0].enMessage);
                } else if (error.debug) {
                    toastError(error.debug);
                } else {
                    toastError("Unknown Error");
                    console.error(error);
                }
            }
        };
    }, []);
};

const useGeneralErrorHandler = (): ErrorHandler => {
    const onAuthErrorHandler = useGeneralErrorHandlerCreator();
    return useMemo(
        () => composeErrorHandlers(onAuthErrorHandler),
        [onAuthErrorHandler],
    );
};

export default useGeneralErrorHandler;
